import API from '@/api/api.js'
import Moment from 'moment';

export default class CartAPIList {
	constructor() {
		let api = new API();
		this.api = api;
	}

	createUserAddress(param, success, error) {
		this.api.post('/address/create', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	editUserAddress(param, success, error) {
		this.api.post('/address/edit', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	createOrder(param, success, error) {
		this.api.post('/order/create', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	pay(param, success, error) {
		this.api.post('/order/pay', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	getWechatConfig(param, success, error) {
		this.api.post('/order/wechatConfig', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	getOrderList(param, success, error) {
		this.api.get('/order', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	getAuthCode(param, success, error) {
		this.api.get('/order/getAuthCode', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	wechatPay(param, success, error) {
		this.api.post('/order/wechatPay', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	cancelOrder(param, success, error) {
		this.api.post('/order/cancel', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}

	setOrderStatus(param, success, error) {
		this.api.post('/order/setOrderStatus', param,
			(json) => {
				success(json);
			}, (err) => {
				error(err);
			});
	}
}



// WEBPACK FOOTER //
// ./src/api/Cart/apiList.js